import { ValueToFormatedTextBaseValueConverter } from 'General/Resources/ValueConverters/ValueToFormatedTextBase';
export class ValueToFormatedTextValueConverter extends ValueToFormatedTextBaseValueConverter {

}